import { CompositeEditorProps, default as CompositeEditorType } from './components/CompositeEditor';
import IEditor from './components/IEditor';
import { ReactEditorProps } from './components/ReactEditor';
import PluginViewStateAdapter from './store/schema/PluginViewStateAdapter';
import { createLazyComponent, LazyImport, LazyModule, LazyModuleType } from 'owa-bundling';
export { ComponentClass } from 'react';
export { EditorPluginEx, PluginUtils } from './utils/PluginUtils';
export { UndoService } from 'roosterjs-editor-core';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));

export let ReactEditor = createLazyComponent<
    ReactEditorProps,
    LazyModuleType<typeof lazyModule>,
    IEditor
>(lazyModule, m => m.ReactEditor);
export let CompositeEditor = createLazyComponent<
    CompositeEditorProps,
    LazyModuleType<typeof lazyModule>,
    CompositeEditorType
>(lazyModule, m => m.CompositeEditor);
export let lazyCreateUndo = new LazyImport(lazyModule, m => m.createUndo);
export let lazySetTableHeaderRow = new LazyImport(lazyModule, m => m.setTableHeaderRow);

export { IEditor, ReactEditorProps, CompositeEditorProps, PluginViewStateAdapter };
